import Vue from 'vue'
import Router from 'vue-router'

import store from '@/store/index'
// functions.useFunctionsEmulator('http://localhost:5001')
// functionsSP.useFunctionsEmulator('http://localhost:5001')

const Home = () => import('./views/Home')
const Board = () => import('./views/Board')
const Decorator = () => import('./views/Decorator.vue')
const NotAuthorized = () => import('./views/NotAuthorized.vue')

function lazyLoadRoute(route) {
  return () => import(`./views/configs/${route}`).catch((error) => {
    console.error(`Erro ao carregar rota lazy: ${route}`, error)
    return { default: { template: '<div>Erro ao carregar componente</div>' } }
  })
}

Vue.use(Router)
// Verificar se o Vue e o Router foram carregados corretamente
if (!Vue || !Router) {
  throw new Error('Falha ao carregar Vue ou VueRouter')
}
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: Decorator,
      children: [
        {
          path: '/',
          name: 'Visão Geral',
          meta: { notAllowed: ['administrator'] },
          component: Home
        },
        {
          path: '/billing',
          name: 'Faturamento',
          meta: { notAllowed: ['manager', 'supervisor', 'attendant'] },
          component: lazyLoadRoute('Billing.vue')
        },
        {
          path: '/companies',
          name: 'Empresas',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Companies.vue')
        },
        {
          path: '/company',
          name: 'Nova empresa',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Company.vue')
        },
        {
          path: '/company/:iuid',
          name: 'Editar empresa',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Company.vue'),
          props: true
        },
        {
          path: '/customers',
          name: 'Clientes',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('Customers.vue')
        },
        {
          path: '/board',
          name: 'Oportunidades',
          meta: {
            notAllowed: ['administrator']
          },
          component: Board
        },
        {
          path: '/schedules',
          name: 'Agendamentos',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('Schedules.vue')
        },
        {
          path: '/customer/:iuid',
          name: 'Cliente',
          meta: {
            notAllowed: ['administrator']
          },
          props: true,
          component: lazyLoadRoute('Customer.vue')
        },
        {
          path: '/info/:cpf',
          name: 'Informações',
          meta: {
            notAllowed: []
          },
          props: true,
          component: lazyLoadRoute('Customer.vue')
        },
        {
          path: '/distributions',
          name: 'Distribuições',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distributions.vue')
        },
        {
          path: '/distribution',
          name: 'Nova distribuição',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distribution.vue')
        },
        {
          path: '/distribution/:iuid',
          name: 'Editar distribuição',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Distribution.vue'),
          props: true
        },
        {
          path: '/goals',
          name: 'Metas',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Goals.vue')
        },
        {
          path: '/goal',
          name: 'Nova meta',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Goal.vue')
        },
        {
          path: '/goal/:iuid',
          name: 'Editar meta',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Goal.vue'),
          props: true
        },
        {
          path: '/stores',
          name: 'Lojas',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Stores.vue')
        },
        {
          path: '/store',
          name: 'Nova loja',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Store.vue')
        },
        {
          path: '/store/:iuid',
          name: 'Editar loja',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Store.vue'),
          props: true
        },
        {
          path: '/uploads',
          name: 'Uploads',
          meta: { notAllowed: ['manager', 'supervisor', 'attendant'] },
          component: lazyLoadRoute('Uploads.vue')
        },
        {
          path: '/upload',
          name: 'Upload',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Upload.vue')
        },
        {
          path: '/upload-preview',
          name: 'Upload com Preview',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('UploadWithPreview.vue')
        },
        {
          path: '/mdb-converter',
          name: 'Conversor MDB',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant'] // Apenas admins podem acessar
          },
          // Assumindo que você salvou o arquivo em /views/MdbConverter.vue
          component: lazyLoadRoute('MdbConverter.vue')
        },
        {
          path: '/notification-test',
          name: 'Teste de Notificações',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: () => import('./views/notificationtest.vue')
        },
        {
          path: '/users',
          name: 'Usuários',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Users.vue')
        },
        {
          path: '/user',
          name: 'Novo usuário',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('User.vue')
        },
        {
          path: '/user/:iuid',
          name: 'Editar usuário',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('User.vue'),
          props: true
        },
        {
          path: '/branches',
          name: 'Filiais',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Branches.vue')
        },
        {
          path: '/branch',
          name: 'Nova filial',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Branch.vue')
        },
        {
          path: '/branch/:iuid',
          name: 'Editar filial',
          meta: {
            notAllowed: ['supervisor', 'attendant']
          },
          component: lazyLoadRoute('Branch.vue'),
          props: true
        },
        {
          path: '/banks',
          name: 'Bancos',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Banks.vue')
        },
        {
          path: '/bank',
          name: 'Novo banco',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Bank.vue')
        },
        {
          path: '/bank/:iuid',
          name: 'Editar banco',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Bank.vue'),
          props: true
        },
        {
          path: '/campaigns',
          name: 'Campanhas',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Campaigns.vue')
        },
        {
          path: '/campaign',
          name: 'Nova campanha',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue')
        },
        {
          path: '/campaign/:iuid',
          name: 'Editar campanha',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue'),
          props: true
        },
        {
          path: '/campaign/:iuid/clone',
          name: 'Clonar campanha',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Campaign.vue'),
          props: true
        },
        {
          path: '/status',
          name: 'Novo Ciclo',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Status.vue')
        },
        {
          path: '/statuses',
          name: 'Status',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Statuses.vue')
        },
        {
          path: '/status/:iuid',
          name: 'Editar Status',
          meta: {
            notAllowed: ['attendant']
          },
          component: lazyLoadRoute('Status.vue'),
          props: true
        },
        {
          path: '/blacklists',
          name: 'Blacklists',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Blacklists.vue'),
          props: true
        },
        {
          path: '/blacklist/:iuid',
          name: 'Blacklist',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('Blacklist.vue'),
          props: true
        },
        {
          path: '/report',
          name: 'Relatórios',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: lazyLoadRoute('Report.vue')
        },
        {
          path: '/bank-operation-rates',
          name: 'Tabelas de Operação',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: () => import('./views/configs/BankOperationRates.vue')
        },
        {
          path: '/bank-operation-rate',
          name: 'Nova Tabela de Operação',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: () => import('./components/BankOperationRate.vue')
        },
        {
          path: '/bank-operation-rate/:rateId',
          name: 'Editar Tabela de Operação',
          meta: {
            notAllowed: ['administrator', 'attendant']
          },
          component: () => import('./components/BankOperationRate.vue'),
          props: true
        },
        {
          path: '/contracts',
          name: 'Contratos',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('ContractTyping.vue')
        },
        {
          path: '/contract/new',
          name: 'Novo Contrato',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('ContractForm.vue')
        },
        {
          path: '/contract/:id/edit',
          name: 'Editar Contrato',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('ContractForm.vue'),
          props: true
        },
        {
          path: '/contract/:id/view',
          name: 'Visualizar Contrato',
          meta: {
            notAllowed: ['administrator']
          },
          component: lazyLoadRoute('ContractView.vue'),
          props: true
        },
        {
          path: '/security-dashboard',
          name: 'Dashboard de Segurança',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('SecurityDashboard.vue')
        },
        {
          path: '/profile/security',
          name: 'Segurança da Conta',
          meta: {
            notAllowed: [] // Todos podem acessar sua própria página de segurança
          },
          component: lazyLoadRoute('ProfileSecurity.vue')
        },
        {
          path: '/configs/user',
          name: 'Meu Perfil',
          meta: {
            notAllowed: [] // Todos podem acessar seu próprio perfil
          },
          component: lazyLoadRoute('ProfileSecurity.vue') // Usar o mesmo componente
        },
        {
          path: '/admin/notifications',
          name: 'Notificações Administrativas',
          meta: {
            notAllowed: ['manager', 'supervisor', 'attendant']
          },
          component: lazyLoadRoute('AdminNotifications.vue')
        },
        {
          path: '/tutorials',
          name: 'Tutoriais',
          meta: {
            notAllowed: [] // Acesso permitido a todos (controle interno por role)
          },
          component: lazyLoadRoute('Tutorials.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      meta: { noAuth: true },
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue'),
      redirect: '/login/sign-in',
      children: [
        {
          path: 'sign-in',
          name: 'sign-in',
          meta: { noAuth: true },
          component: () => import('./components/login/SignIn.vue')
        },
        {
          path: 'sign-up',
          name: 'sign-up',
          meta: { noAuth: true },
          component: () => import('./components/login/SignUp.vue')
        }
      ]
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      meta: { noAuth: true },
      component: () => import(/* webpackChunkName: "forgot-password" */ './views/ForgotPassword.vue')
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      meta: { noAuth: true },
      component: () => import(/* webpackChunkName: "reset-password" */ './views/ResetPassword.vue')
    },
    {
      path: '/notAuthorized',
      name: 'Não Autorizado',
      component: NotAuthorized
    }
  ]
})

/**
 * 🔐 UTILITÁRIO PARA DECODIFICAR JWT COM SEGURANÇA
 * Função auxiliar para decodificação segura de tokens JWT
 */
function parseJwtSafely(token) {
  try {
    if (!token || typeof token !== 'string') {
      return null
    }

    const parts = token.split('.')
    if (parts.length !== 3) {
      console.warn('⚠️ Token JWT com formato inválido')
      return null
    }

    // Adiciona padding se necessário
    let base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/')
    while (base64.length % 4) {
      base64 += '='
    }

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    )

    return JSON.parse(jsonPayload)
  } catch (error) {
    console.error('❌ Erro ao decodificar JWT:', error)
    return null
  }
}

/**
 * 🔐 VERIFICA SE O TOKEN ESTÁ VÁLIDO
 */
function isTokenValid(token) {
  if (!token) return false

  try {
    const payload = parseJwtSafely(token)
    if (!payload) return false

    const currentTime = Date.now() / 1000
    return payload.exp > currentTime
  } catch (error) {
    console.error('❌ Erro ao verificar token:', error)
    return false
  }
}

/**
 * 🔐 VERIFICA PERMISSÕES DE IP (substitui Firebase Function)
 */
/** async function verifyIpAddress(user) {
  try {
    // Chama a função equivalente no backend
    const verifyIpFunction = functions.httpsCallable('verifyIpAddressOnCall')
    await verifyIpFunction()
    return true
  } catch (error) {
    console.error('❌ Erro na verificação de IP:', error)

    // Faz logout se IP não permitido
    await auth.signOut()

    if (error.message === 'The IP address is out of range.') {
      if (typeof window !== 'undefined') {
        window.alert('Você está fora do seu horário de serviço!')
      }
    }

    throw error
  }
}/*

/**
 * 🔐 ROUTE GUARD PRINCIPAL
 * Substitui completamente o Firebase Auth
 */
router.beforeEach(async(to, from, next) => {
  try {
    console.log('🔐 Route Guard: Verificando acesso para', to.path)

    // 🔓 ROTAS PÚBLICAS (não precisam de autenticação)
    if (to.meta.noAuth) {
      console.log('✅ Rota pública, permitindo acesso')
      return next()
    }

    // 🔐 VERIFICA SE USUÁRIO ESTÁ AUTENTICADO VIA NOVO SISTEMA
    const token = typeof localStorage !== 'undefined' ? localStorage.getItem('auth_token') : null
    const userData = typeof localStorage !== 'undefined' ? localStorage.getItem('user_data') : null

    // Se localStorage falhar, redirecionar para login
    if (!token || !userData) {
      console.log('❌ Token ou dados do usuário ausentes')
      // Não limpar localStorage imediatamente - pode ser login recente
      if (to.path !== '/login') {
        localStorage.clear() // Limpar apenas se não for tentativa de login
      }
      return next('/login')
    }

    // Verificar token com mais detalhes
    if (!isTokenValid(token)) {
      console.log('❌ Token expirado ou inválido')
      localStorage.clear()
      return next('/login')
    }

    // 🎫 DECODIFICA DADOS DO USUÁRIO
    let user
    try {
      user = JSON.parse(userData)

      // Garante compatibilidade com Firebase
      if (!user.uid && user.id) user.uid = user.id
      if (!user.profile && user.role) user.profile = user.role
    } catch (error) {
      console.log('❌ Dados do usuário inválidos, redirecionando para login')
      return next('/login')
    }
    console.log('👤 Usuário autenticado:', {
      uid: user.uid,
      email: user.email,
      profile: user.profile,
      companyId: user.companyId
    })
    // 🌐 VERIFICA IP (temporariamente desabilitado)
    // TODO: Implementar verificação de IP no backend
    // try {
    //   await verifyIpAddress(user)
    // } catch (ipError) {
    //   console.log('❌ Falha na verificação de IP')
    //   return next('/login')
    // }

    // 💾 ATUALIZA USUÁRIO NO STORE
    await store.dispatch('setUser', user)

    // Antes da verificação de permissões
    // console.log('🔍 Debug - Token:', token ? 'presente' : 'ausente')
    // console.log('🔍 Debug - UserData:', userData ? 'presente' : 'ausente')
    // console.log('🔍 Debug - User parsed:', user)
    // console.log('🔍 Debug - Route meta:', to.meta)
    // 🛡️ VERIFICA PERMISSÕES DA ROTA
    const { notAllowed } = to.meta
    if (notAllowed && notAllowed.includes(user.profile)) {
      console.log(`❌ Perfil '${user.profile}' não autorizado para esta rota`)

      // 🔄 Redirecionar para rota padrão do perfil em vez de bloquear
      const defaultRoutes = { administrator: '/companies', manager: '/', supervisor: '/', attendant: '/' }
      const fallbackRoute = defaultRoutes[user.profile] || '/'

      // 🚫 Evitar loop de redirecionamento
      if (to.path === fallbackRoute) {
        console.log(`⚠️ Loop detectado: usuário já está na rota padrão ${fallbackRoute}, enviando para /notAuthorized`)
        return next('/notAuthorized')
      }

      console.log(`🔄 Redirecionando ${user.profile} para rota padrão: ${fallbackRoute}`)
      return next(fallbackRoute)
    }

    // 📊 ATUALIZA CONTADORES
    store.dispatch('updateScheduleCount')

    // 🏠 REDIRECIONAMENTO ESPECÍFICO PARA ADMINISTRADORES
    if (to.path === '/' && user.profile === 'administrator') {
      console.log('🔄 Redirecionando administrador para /companies')
      return next('/companies')
    }
    console.log('✅ Acesso autorizado para', to.path)
    return next()
  } catch (error) {
    console.error('❌ Erro no route guard:', error)
    // Em caso de erro, redireciona para login
    return next('/login')
  }
})

/**
 * 🔄 INTERCEPTADOR APÓS NAVEGAÇÃO
 * Para limpeza e logs adicionais
 */
router.afterEach((to, from) => {
  console.log('🔄 Navegação concluída:', from.path, '→', to.path)
})

export default router
